export const commonEnvironment = {
  dpcmRedirectionFlag: 'cp-20128-discrete-and-power-cost-sme-model',
  newSignupMinThreshold: 5,
  displayableCategoryTagTypes: ['application', 'technology', 'purpose', 'theme', 'coverage_area'],
}
